import { useNavigate } from 'react-router-dom'

const plans = [
  {
    name: 'Basic',
    price: '₹999',
    color: '#6b7280',
    features: [
      'Top 5 options anomaly alerts',
      'Telegram delivery',
      'Morning market scan',
    ],
  },
  {
    name: 'Pro',
    price: '₹2,499',
    color: '#00d4ff',
    features: [
      'Top 15 options anomalies',
      'Wavelet analysis',
      'Strategy hints',
      'Signal history (7 days)',
    ],
    highlight: true,
  },
  {
    name: 'Elite',
    price: '₹4,999',
    color: '#f59e0b',
    features: [
      'Everything in Pro',
      'Priority Telegram delivery',
      'Custom watchlist',
      'Onboarding call',
    ],
  },
]

export default function Landing() {
  const navigate = useNavigate()

  return (
    <div style={styles.container}>
      <nav style={styles.nav}>
        <span style={styles.navLogo}>AITradeMinds</span>
        <div>
          <button style={styles.navBtn} onClick={() => navigate('/login')}>
            Login
          </button>
          <button style={styles.navBtnPrimary} onClick={() => navigate('/register')}>
            Start Free Trial
          </button>
        </div>
      </nav>

      <div style={styles.hero}>
        <h1 style={styles.heroTitle}>
          NSE F&O Options Flow Intelligence
        </h1>
        <p style={styles.heroSub}>
          Scan 203 F&O stocks every 15 minutes. Detect unusual options activity
          before the market moves. Powered by OI spike, IV crush, and wavelet analysis.
        </p>
        <button style={styles.heroCTA} onClick={() => navigate('/register')}>
          Start 7-Day Free Trial
        </button>
        <p style={styles.heroDisclaimer}>
          ⚠️ Research intelligence only. Not SEBI registered investment advice.
        </p>
      </div>

      <div style={styles.stats}>
        {[
          { value: '203', label: 'F&O Stocks Scanned' },
          { value: '15min', label: 'Scan Interval' },
          { value: '4', label: 'Anomaly Types' },
          { value: '9:15AM', label: 'Market Open Alert' },
        ].map(s => (
          <div key={s.label} style={styles.statCard}>
            <div style={styles.statValue}>{s.value}</div>
            <div style={styles.statLabel}>{s.label}</div>
          </div>
        ))}
      </div>

      <div style={styles.plansSection}>
        <h2 style={styles.plansTitle}>Choose Your Plan</h2>
        <div style={styles.plans}>
          {plans.map(plan => (
            <div
              key={plan.name}
              style={{
                ...styles.planCard,
                border: plan.highlight
                  ? '2px solid #00d4ff'
                  : '1px solid #1f2937',
              }}
            >
              {plan.highlight && (
                <div style={styles.popularBadge}>Most Popular</div>
              )}
              <h3 style={{ color: plan.color, marginTop: 0 }}>{plan.name}</h3>
              <div style={styles.planPrice}>{plan.price}<span style={styles.planPer}>/month</span></div>
              <ul style={styles.featureList}>
                {plan.features.map(f => (
                  <li key={f} style={styles.featureItem}>✓ {f}</li>
                ))}
              </ul>
              <button
                style={{ ...styles.planBtn, background: plan.color }}
                onClick={() => navigate('/register')}
              >
                Get Started
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

const styles: Record<string, React.CSSProperties> = {
  container: { background: '#0a0e1a', minHeight: '100vh', color: '#fff' },
  nav: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    padding: '20px 40px', borderBottom: '1px solid #1f2937',
  },
  navLogo: { color: '#00d4ff', fontSize: 22, fontWeight: 700 },
  navBtn: {
    background: 'transparent', color: '#9ca3af', border: '1px solid #374151',
    padding: '8px 20px', borderRadius: 6, cursor: 'pointer', marginRight: 12,
  },
  navBtnPrimary: {
    background: '#00d4ff', color: '#000', border: 'none',
    padding: '8px 20px', borderRadius: 6, cursor: 'pointer', fontWeight: 700,
  },
  hero: { textAlign: 'center', padding: '80px 40px 40px' },
  heroTitle: { fontSize: 42, fontWeight: 800, color: '#fff', marginBottom: 20 },
  heroSub: { fontSize: 18, color: '#9ca3af', maxWidth: 600, margin: '0 auto 32px' },
  heroCTA: {
    background: '#00d4ff', color: '#000', border: 'none',
    padding: '16px 40px', borderRadius: 8, fontSize: 18,
    fontWeight: 700, cursor: 'pointer',
  },
  heroDisclaimer: { color: '#4b5563', fontSize: 12, marginTop: 16 },
  stats: {
    display: 'flex', justifyContent: 'center', gap: 24,
    padding: '40px', flexWrap: 'wrap',
  },
  statCard: {
    background: '#111827', border: '1px solid #1f2937',
    borderRadius: 12, padding: '24px 32px', textAlign: 'center',
  },
  statValue: { fontSize: 32, fontWeight: 800, color: '#00d4ff' },
  statLabel: { color: '#6b7280', fontSize: 13, marginTop: 4 },
  plansSection: { padding: '40px', textAlign: 'center' },
  plansTitle: { fontSize: 28, marginBottom: 40 },
  plans: { display: 'flex', justifyContent: 'center', gap: 24, flexWrap: 'wrap' },
  planCard: {
    background: '#111827', borderRadius: 12, padding: 32,
    width: 260, position: 'relative', textAlign: 'left',
  },
  popularBadge: {
    position: 'absolute', top: -12, left: '50%', transform: 'translateX(-50%)',
    background: '#00d4ff', color: '#000', padding: '4px 16px',
    borderRadius: 20, fontSize: 12, fontWeight: 700,
  },
  planPrice: { fontSize: 36, fontWeight: 800, color: '#fff', marginBottom: 24 },
  planPer: { fontSize: 14, color: '#6b7280', fontWeight: 400 },
  featureList: { listStyle: 'none', padding: 0, marginBottom: 24 },
  featureItem: { color: '#9ca3af', padding: '6px 0', fontSize: 14 },
  planBtn: {
    width: '100%', padding: '12px', border: 'none',
    borderRadius: 8, fontWeight: 700, cursor: 'pointer', color: '#000',
  },
}